import { QuestionBase } from '../../classes/questions/question-base';

export const getQuestion = <T extends QuestionBase>(
  key: string,
  questions: QuestionBase[],
): T => questions.find(question => question.key === key) as T;
